import { AnyDocument } from '../../../types';
import { ConstructDelete } from '../../types/ConstructDelete';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const deleteDocumentById = async (
  constructDelete: ConstructDelete,
  documentId: string,
  documentParams: DocumentParams,
): Promise<NonPaginatedResponse<AnyDocument> | undefined> =>
  constructDelete(
    `${DOCUMENTS_BASE_PATH}/${documentId}/document`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
    { preventDefaultErrorToast: true },
  );
